import "./style.scss";

class Collapse {
	constructor(element) {
		this.collapse = element;
		this.triggers = this.collapse.querySelectorAll('.collapse-trigger');
		this.panels = this.collapse.querySelectorAll('.collapse-panel');
	}
	init() {
		this.panels.forEach(panel => {
			if (panel.classList.contains("is-active")) {
				console.log( panel.scrollHeight)
				panel.style.maxHeight = panel.scrollHeight + "px";
			} else {
				panel.style.maxHeight = 0;
				console.log( panel.scrollHeight)
			} 
		})

		this.triggers.forEach(trigger => {
			
			trigger.addEventListener('click', (e) => {
				// trigger.classList.toggle("is-active");
				let thePanel = this.collapse.querySelector(`.collapse-panel[data-collapse='${trigger.dataset.collapse}']`)
				thePanel.classList.toggle('is-active');
	
				if (thePanel.classList.contains("is-active")) {
					
					thePanel.style.maxHeight = thePanel.scrollHeight + "px";
				} else {
					thePanel.style.maxHeight = 0;
				} 
			})
		})
	}
}



document.addEventListener(
	"DOMContentLoaded",
	() => {
		document.querySelectorAll('.js-collapse').forEach(acc =>{
			const collapse = new Collapse(acc);
			collapse.init();
		})
	}
)